var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-pagination',{staticClass:"custom-pagination",attrs:{"value":_vm.currentPage,"total-rows":_vm.totalItems,"per-page":_vm.perPage,"first-number":"","last-number":"","prev-text":_vm.$t('GLOBAL.PREV'),"next-text":_vm.$t('GLOBAL.NEXT')},on:{"input":_vm.onPageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }